export default function parseErrorMessage(error: unknown, defaultMessage = 'Unknown error') {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  return defaultMessage;
}
